export enum ApplicationStatusReason {
    EMPLOYEE_EXIT = 'EMPLOYEE_EXIT'
}
